import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AssetList from './adms/AssetList';
import AssetCard from './adms/AssetCard';
import DocsList from './docs/DocList';
import DocCard from './docs/DocCard';
import EMDHistoryList from './emd/HistoryList';
import EMDHistoryCard from './emd/HistoryCard';
import EMDCard from './emd/EMDCard';
import IEPCard from './iep/IEPCard';
import XSDViewerProxy from './xsd/XSDViewerProxy';
import LinkerCard from './linker/LinkerCard';


//Представление списка элементов ADMS каталога
//Передаётся:
//  1. описания adms каталога 
//  3. метод dispatch и history. Первый для операций загрузки отдельных элементов, второй для навигации
export const AssetListViewBase = withRouter(connect(
  (state, props) => {
    const { vadms, vset } = state;
    return ({
      ...vadms, isSignedIn: vset.isSignedIn, lang: vset.lang
    })
  },
  dispatch => ({
    onRefreshList(actions, conditions){
      //console.log("containers.js onRefreshList(actions, conditions)", conditions);
      //Для ADMS actions является AdmsRepository
      return dispatch(actions.loadAssets(conditions));
    },
    
    onChangeConditions (actions, conditions) {
      if (actions) 
        return dispatch(actions.CONDITIONS(conditions));
    },

    //Поиск по наименование (с учётом уже наложенных условий отбора)
    //Для SPARQL это contains(?dsn, "убл") strStarts(?dsn, "Д")
    onNameSearch (actions, pattern, conditions) {
      if (actions) { 
        const c = conditions.filter(item => !((item.predicate=="http://www.w3.org/2000/01/rdf-schema#label")&&(item.operator=="contains")));
        const filter = (!pattern)? c : c.concat({predicate: "http://www.w3.org/2000/01/rdf-schema#label", operator: "contains", value: pattern, alias:"dsn", label:pattern});
        //console.log("onNameSearch (actions, pattern, conditions)", pattern, conditions, c, filter);
        return dispatch(actions.CONDITIONS(filter)); //loadAssets(filter));
      };
    },

    //Поиск по алфавите (с учётом уже наложенных условий отбора)
    //Для SPARQL strStarts(?dsn, "Д")
    onAlphabetSearch(actions, pattern, conditions) {
      if (actions) {
        const c = conditions.filter(item => !((item.predicate=="http://www.w3.org/2000/01/rdf-schema#label")&&(item.operator=="strStarts")));
        //Текущее условие отбора по алфавиту
        const l = conditions.filter(item => ((item.predicate=="http://www.w3.org/2000/01/rdf-schema#label")&&(item.operator=="strStarts")));
        //Есть ли в условии такая же буква
        const hasPattern  = (l.length <1)? false: Array.isArray(l[0].value)? l[0].value.includes(pattern): l[0].value==pattern;
        //Есть условие - удалить букву из списка, нет - добавить
        const value = (hasPattern)?
            (Array.isArray(l[0].value))? l[0].value.filter(char => char!=pattern):""
          :  (l.length <1)? pattern: (Array.isArray(l[0].value))? l[0].value.concat(pattern):[l[0].value, pattern];
        const label = (Array.isArray(value))? value.join(", "): value;
        //Проверим, что условие пусто (т.е. "отжали все буквы")
        const isEmpty = !value || (value == "") || (Array.isArray(value) && (value.length==0))
        const filter = (isEmpty)? c : c.concat({predicate: "http://www.w3.org/2000/01/rdf-schema#label", operator: "strStarts", value, alias:"dsn", label});
        //console.log("onAlphabetSearch (actions, pattern, conditions)", pattern, conditions, c, filter);
        return dispatch(actions.CONDITIONS(filter)); //loadAssets(filter));
      };
    },
  })
)(AssetList));

export const AssetListView = withRouter(connect(
  null,
  dispatch => ({
    onSelected (IRI, actions, history){
      //console.log("containers.js onSelected", IRI, actions, IRI.startsWith("http://hbz.local/adms/pie#"));
      if (IRI.toUpperCase().lastIndexOf("EMD")==(IRI.length-3)){
        history.push("/viewemd/"+encodeURIComponent(IRI));
        return;
      }      
      if (IRI.startsWith("http://hbz.local/adms/pie#") || IRI.startsWith("http://hbz.local/adms/eip#")){
        history.push("/vieweip/"+encodeURIComponent(IRI));
        return;
      }
      history.push("/adms/"+encodeURIComponent(IRI));
    },

    onAddElement (actions, catalog, iri, type, label, lang){
      return dispatch(actions.addElement(catalog, iri, type, label, lang));
    },
  })
)(AssetListViewBase));
  
export const AssetCardView = withRouter(connect(
  (state, props) => {
    const { vset, vasset, vviews} = state;
    const { lang } = props;
    return ({
      lang: (lang)?lang: vset.lang,
      isSignedIn: vset.isSignedIn,
      IRI: vasset.iri,
      state: vasset.state,
      values: vasset.values,      //Текущие данные
      vviews,                     //Список представлений
    })
  },
  dispatch => ({
    onDeleteElement (actions, catalog, iri){
      return dispatch(actions.deleteElement(catalog, iri));
    },
    onUnlinkElement (actions, catalog, iri){
      return dispatch(actions.unlinkElement(catalog, iri));
    },
    onDetailElement (actions, catalog, triplet){
      return dispatch(actions.onDetailElement(triplet));
    },
    onReload (actions, catalog, IRI){
      return dispatch(actions.loadSelected(IRI));
    },
    onReloadViews (actions, IRI){
      return dispatch(actions.loadViews(IRI));
    },
    onAddProperty (actions, IRI, predicat, lang){
      return dispatch(actions.addProperty(IRI, predicat, lang));
    },
    onRemoveProperty(actions, IRI, predicat){
      return dispatch(actions.removeProperty(IRI, predicat));
    },
  })
)(AssetCard))

//Представление информации о ЕМД
export const EMDCardView = withRouter(connect(
  (state, props) => {
    //console.log("EMDCardView containers", props);
    const { vset, vasset, emd, vviews} = state;
    const { lang } = props;
    return ({
      lang: (lang)?lang: vset.lang,
      isSignedIn: vset.isSignedIn,
      IRI: vasset.iri,
      values: vasset.values,      //Текущие данные
      state: vasset.state,
      content: emd.content,
      vviews
    })
  },
  dispatch => ({
    onReload (adms, emd, catalog, IRI){
      return Promise.all([dispatch(adms.loadSelected(IRI)), dispatch(emd.loadContent(IRI))]);
    },
    //Событие, которое загружает содержимое
    onContentSelected (actions, catalog, iri){
      if (actions)
        dispatch(actions.loadContent(NodId, repository));
    },
    onReloadViews (actions, IRI){
      return dispatch(actions.loadViews(IRI));
    },
  })
)(EMDCard))

//Представление информации о пакете информационного обмена
export const IEPCardView = withRouter(connect(
  (state, props) => {
    const { vset, vasset, emd} = state;
    const { lang } = props;
    return ({
      lang: (lang)?lang: vset.lang,
      isSignedIn: vset.isSignedIn,
      IRI: vasset.iri,
      values: vasset.values,      //Текущие данные
      state: vasset.state,
            // adms: state.adms.description,
            // taxonomy: state.adms.schemas,
            // //Репозиторий для загружки содержимого пакета
            // repository: state.pie.repository,
            // asset:state.pie.selected
    })
  },
  dispatch => ({
        //Событие, которое загружает содержимое
        onReload (adms, iep, catalog, IRI){
          return Promise.all([dispatch(adms.loadSelected(IRI)), dispatch(iep.loadContent(IRI))]);
        },
  })
)(IEPCard))

export const DocsListView = connect(
    (state, props) => {
        return ({
            docs: state.docs.description,
        })
    },
    dispatch => ({
        onSelected (NodId){
        }
    })
)(DocsList)    

export const DocCardView = connect(
    (state, props) => {
        return ({
            docs: state.docs.description,
        })
    },
    null
)(DocCard)

export const EMDHistoryListView = withRouter(connect(
  (state, props) => {
    const { vset,vadms, vasset } = state;
    const { lang } = props;
    return ({
      lang: (lang)?lang: vset.lang,
      isSignedIn: vset.isSignedIn,
      IRI: vasset.iri,
      ...vadms
    })
  },
  dispatch => ({
    onRefreshList(actions, conditions){
      //Для ADMS actions является AdmsRepository
      return dispatch(actions.loadAssets(conditions));
    },
    onSelected (IRI, history){
      history.push("/emd/"+encodeURIComponent(IRI));
    },  
  })
)(EMDHistoryList));

export const EMDHistoryCardView = withRouter(connect(
  (state, props) => {
    const { vset,vadms, vasset } = state;
    const { lang } = props;
    return ({
      lang: (lang)?lang: vset.lang, 
      isSignedIn: vset.isSignedIn,
      IRI: vasset.iri,
      ...vadms
    })
  },
  dispatch => ({
    onRefreshList(actions, conditions){
      //Для ADMS actions является AdmsRepository
      return dispatch(actions.loadAssets(conditions));
    },
    onSelected (IRI, history){
      history.push("/emd/"+encodeURIComponent(IRI));
    },  
  })
)(EMDHistoryCard));


export const XSDViewer = connect(
  (state, props) => {
      return ({
        content: state.xsd.content,
      })
  },
  null
)(XSDViewerProxy)

export const LinkerViewer = connect(
  (state, props) => {
      return ({
        linker: state.linker,
      })
  },
  null
)(LinkerCard)
